import type { AdminRouterContext } from '@/lib/router-context'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { SuperTicketSettings } from '@/components/orders/SuperTicketSettings'
import { useIsReadOnly } from '@/lib/casl'
import { adminTitleHead } from '@/lib/admin-route-title'
import { superTicketQueries } from '@/lib/services/super-ticket-settings/super-ticket-settings.query'

export const loadSuperTicketSettingsRoute = async ({
  context,
  params,
}: {
  context: AdminRouterContext
  params: { orgId: number }
}) => {
  const isReadOnly = !context.ability.can('edit', 'super-ticket-settings')
  if (isReadOnly && !context.ability.can('view', 'sales-orders')) throw notFound()
  // Open with fresh defaults; the mounted editor then owns its layout and version.
  await context.queryClient.fetchQuery(superTicketQueries.catalog({ organizationId: params.orgId }))
  return { isReadOnly }
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/supertickets/')({
  component: SuperTicketSettingsPage,
  head: () => adminTitleHead('Supertickets', 'Settings'),
  loader: loadSuperTicketSettingsRoute,
})

export function SuperTicketSettingsPage() {
  const { orgId } = Route.useParams()
  const { isReadOnly } = useIsReadOnly()
  const { data: catalog } = useSuspenseQuery(superTicketQueries.catalog({ organizationId: orgId }))
  return (
    <SuperTicketSettings
      key={orgId}
      organizationId={orgId}
      catalog={catalog}
      isReadOnly={isReadOnly}
    />
  )
}
